<template>
    <infinite-scroller-horizontal title="Suggestions" @scrolledTillRight="scrolledTillRight">
        <template>
            <v-col cols="auto" v-for="user in suggestedUsers" :key="'suggested-user-mob-' + user.id">
                <card-user :userDetail="user" width=150></card-user>
            </v-col>
        </template>
    </infinite-scroller-horizontal>
</template>
<script>
import suggestedUsersMixin from "@/mixins/mixin-suggested-users"
export default {
    mixins: [suggestedUsersMixin]
}
</script>